import React from 'react';
import PropTypes from 'prop-types';

const getHtml = (content) => {
  // to the fix bug with checking for empty string ({ __html: '' }) after hydrate
  // we don't return innerHTML prop for the case without content
  if (!content) return;

  const text = Array.isArray(content)
    ? content
      .filter((i) => {
        if (typeof i === 'number') return true;

        return i;
      })
      .join('')
    : content;
  // eslint-disable-next-line consistent-return
  return { dangerouslySetInnerHTML: { __html: text } };
};

const HTML = ({ as: Tag = 'span', children, ...props }) => (
  <Tag
    {...props}
    {...getHtml(children)}
  />
);

HTML.propTypes = {
  as: PropTypes.string,
  children: PropTypes.string,
};

export default HTML;
